import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

const AppStoreButtons = ({
  showText = true,
  className = "",
  iconOnly = false,
  variant = "default", // default, white, black
}) => {
  const googlePlayLink =
    "https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice";
  const appStoreLink =
    "https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468";

  if (iconOnly) {
    return (
      <div
        className={`flex items-center gap-2.5 flex-wrap md:flex-col md:items-start ${className}`}
      >
        {showText && (
          <span className="font-semibold mr-2.5">Download App:</span>
        )}
        <div className="flex flex-wrap gap-2 md:flex-row md:w-full">
          <a
            href={appStoreLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-start px-3 py-2 md:px-5 md:py-2.5 rounded-full no-underline hover:no-underline font-medium border-none bg-white text-black hover:bg-white hover:text-black min-w-auto md:min-w-40 h-11 shadow-md font-sans"
          >
            <FaApple className="w-6 h-6 mr-2.5 flex-shrink-0" />
            <span className="text-base font-semibold tracking-tight leading-none">
              App Store
            </span>
          </a>
          <a
            href={googlePlayLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-start px-3 py-2 md:px-5 md:py-2.5 rounded-full no-underline hover:no-underline font-medium border-none bg-white text-black hover:bg-white hover:text-black min-w-auto md:min-w-40 h-11 shadow-md font-sans"
          >
            <FaGooglePlay className="w-5 h-5 mr-2.5 flex-shrink-0" />
            <span className="text-base font-semibold tracking-tight leading-none">
              Google Play
            </span>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-wrap gap-4 items-center ${className}`}>
      {/* App Store Button */}
      <a
        href={appStoreLink}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center justify-start px-5 py-2.5 rounded-full no-underline hover:no-underline font-medium border-none min-w-40 h-11 shadow-md font-sans ${
          variant === "black"
            ? "bg-black text-white hover:bg-black hover:text-white"
            : "bg-white text-black hover:bg-white hover:text-black"
        }`}
      >
        <FaApple className="w-6 h-6 mr-2.5 flex-shrink-0" />
        <span className="text-base font-semibold tracking-tight leading-none">
          App Store
        </span>
      </a>

      {/* Google Play Button */}
      <a
        href={googlePlayLink}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center justify-start px-5 py-2.5 rounded-full no-underline hover:no-underline font-medium border-none min-w-40 h-11 shadow-md font-sans ${
          variant === "black"
            ? "bg-black text-white hover:bg-black hover:text-white"
            : "bg-white text-black hover:bg-white hover:text-black"
        }`}
      >
        <FaGooglePlay className="w-5 h-5 mr-2.5 flex-shrink-0" />
        <span className="text-base font-semibold tracking-tight leading-none">
          Google Play
        </span>
      </a>
    </div>
  );
};

export default AppStoreButtons;
